import React from "react";
import { Route, Routes } from "react-router-dom";
import Cases from "../../pages/cases";
import ServiceProviders from "../../pages/service-providers";
import CaseDetails from "../../pages/case-details";
import Login from "../../pages/login";
import { Navigate } from "react-router-dom";
import Dentists from "../../pages/dentists";
import Settings from "../../pages/settings";
import OperationsRoutes from "./OperationsRoutes";
import MyAppointments from "../../pages/my-appointments";
import AddNewPatient from "../../pages/add-new-patient";
import TreatmentPlan from "../../pages/treatment-plan";
import ForgotPassword from "../../pages/forgot-password";
import ResetPassword from "../../pages/reset-password";
import PaymentConfirmed from "../../pages/payment-confirmed";
import ServiceProviderSchedule from "../../pages/service-provider-schedule";
import StlSlideShow from "../../pages/stl-slideshow";
import PaymentSummary from "../../pages/payment-summary";
import { BrowserRouter } from "react-router-dom";
import GenerateLink from "../../pages/generate-link";
import PrivacyPolicy from "../../pages/privacy-policy";
const ProtectedLayout = ({ children }) => {
  const token = localStorage.getItem("token");

  if (!token) {
    return <Navigate to="/" />;
  } else {
    return children;
  }
};

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/generate-link" element={<GenerateLink />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/payment-confirmed" element={<PaymentConfirmed />} />
      <Route path="/" element={<OperationsRoutes />}>
        <Route
          path="/dentists"
          element={
            <ProtectedLayout>
              <Dentists />
            </ProtectedLayout>
          }
        />
        <Route
          path="/settings"
          element={
            <ProtectedLayout>
              <Settings />
            </ProtectedLayout>
          }
        />
        

        <Route
          path="settings/service/:serviceId"
          element={
            <ProtectedLayout>
              <ServiceProviders />
            </ProtectedLayout>
          }
        />
        <Route
          path="settings/service/:serviceId/schedule"
          element={
            <ProtectedLayout>
              <ServiceProviderSchedule />
            </ProtectedLayout>
          }
        />
        <Route
          path="/my-appointments"
          element={
            <ProtectedLayout>
              <MyAppointments />
            </ProtectedLayout>
          }
        />
      </Route>
      <Route
        path="/cases"
        element={
          <ProtectedLayout>
            <Cases />
          </ProtectedLayout>
        }
      />
      
      <Route
        path="/cases/add-new-patient"
        element={
          <ProtectedLayout>
            <AddNewPatient />
          </ProtectedLayout>
        }
      />
      <Route
          path="/cases/payment-summary"
          element={
            <ProtectedLayout>
              <PaymentSummary />
            </ProtectedLayout>
          }
        />
      <Route path="/cases/:caseId/">
        <Route
          path=""
          element={
            <ProtectedLayout>
              <CaseDetails />
            </ProtectedLayout>
          }
        />
        <Route path="/cases/:caseId/slide-show" element={<StlSlideShow />} />

        <Route
          path="treatment-plan"
          element={
            <ProtectedLayout>
              <TreatmentPlan />
            </ProtectedLayout>
          }
        />
      </Route>
      <Route path="/privacy" element={<PrivacyPolicy />} />
    </Routes>
  );
};

export default AppRoutes;
